import type { Product } from '@/mocks/products';

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  return (
    <div className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden transition-all duration-300 hover:border-primary-300" data-product-shop>
      <div className="relative overflow-hidden">
        <div className="w-full aspect-square overflow-hidden bg-background-100">
          <img
            src={product.imageUrl}
            alt={product.name}
            title={`${product.name} - 鲍鱼盒子高端礼盒`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        {product.originalPrice && (
          <div className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full">
            限时优惠
          </div>
        )}
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
          {product.name}
        </h3>
        <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
          {product.description}
        </p>
        <div className="flex flex-wrap gap-1.5 mb-4">
          {product.features.slice(0, 3).map((feature, idx) => (
            <span key={idx} className="text-xs text-foreground-500 bg-background-100 px-2 py-1 rounded-md">
              {feature}
            </span>
          ))}
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-baseline gap-2">
            <span className="text-lg md:text-xl font-bold text-accent-600">
              ¥{product.price.toLocaleString()}
            </span>
            {product.originalPrice && (
              <span className="text-sm text-foreground-400 line-through">
                ¥{product.originalPrice.toLocaleString()}
              </span>
            )}
          </div>
          <button className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-shopping-cart-2-line text-sm"></i>
          </button>
        </div>
      </div>
    </div>
  );
}